export const cards = [
    {
        l: "AA",
        a: [
            {t: "c", v: {str:60, ev: -0.5}},
            {t: "f", v: {str: 40, ev: 0.4}},
        ]
    },
    {
        l: "AKs",
        a: [
            {t: "r20", v: {str: 40, ev: 0.4}},
            {t: "r10", v: {str: 20, ev: 0.4}},
            {t: "c", v: {str: 20, ev: -0.5}},
            {t: "f", v: {str: 20, ev: 0.4}},
        ]
    },
    {
        l: "AQs",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]
    },
    {
        l: "AJs",
        a: [
            {t: "r10", v: {str: 50, ev: 0.4}},
            {t: "c", v: {str: 30, ev: -0.5}},
            {t: "f", v: {str: 20, ev: 0.4}},
        ]
    },
    {
        l: "ATs",
        a: [
            {t: "r10", v: {str: 50, ev: 0.4}},
            {t: "c", v: {str: 30, ev: -0.5}},
            {t: "f", v: {str: 20, ev: 0.4}},
        ]

    },
    {
        l: "A9s",
        a: [
            {t: "r30", v: {str: 20, ev: 0.4}},
            {t: "r20", v: {str: 40, ev: 0.4}},
            {t: "r10", v: {str: 20, ev: 0.4}},
            {t: "c", v: {str: 10, ev: -0.5}},
            {t: "f", v: {str: 10, ev: 0.4}},
        ]

    },
    {
        l: "A8s",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "A7s",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "A6s",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "A5s",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "A4s",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "A3s",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "A2s",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },

    {
        l: "AKo",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "KK",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "KQs",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "KJs",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "KTs",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "K9s",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "K8s",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "K7s",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "K6s",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "K5s",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "K4s",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "K3s",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "K2s",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },

    {
        l: "AQo",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "KQo",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "QQ",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "QJs",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "QTs",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "Q9s",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "Q8s",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "Q7s",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "Q6s",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "Q5s",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "Q4s",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "Q3s",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "Q2s",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },

    {
        l: "AJo",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "KJo",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "QJo",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "JJ",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "JTs",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "J9s",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "J8s",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "J7s",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "J6s",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "J5s",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "J4s",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "J3s",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "J2s",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },

    {
        l: "ATo",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "KTo",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "QTo",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "JTo",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "TT",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "T9s",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "T8s",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "T7s",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "T6s",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "T5s",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "T4s",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "T3s",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "T2s",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },

    {
        l: "A9o",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "K9o",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "Q9o",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "J9o",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "T9o",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "99",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "98s",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "97s",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "96s",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "95s",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "94s",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "93s",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "92s",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },

    {
        l: "A8o",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "K8o",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "Q8o",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "J8o",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "T8o",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "98o",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "88",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "87s",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "86s",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "85s",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "84s",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "83s",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "82s",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },

    {
        l: "A7o",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "K7o",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "Q7o",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "J7o",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "T7o",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "97o",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "87o",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "77",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "76s",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "75s",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "74s",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "73s",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "72s",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },

    {
        l: "A6o",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "K6o",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "Q6o",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "J6o",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "T6o",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "96o",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "86o",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "76o",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "66",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "65s",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "64s",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "63s",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "62s",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },

    {
        l: "A5o",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "K5o",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "Q5o",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "J5o",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "T5o",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "95o",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "85o",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "75o",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "65o",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "55",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "54s",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "53s",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "52s",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },

    {
        l: "A4o",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "K4o",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "Q4o",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "J4o",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "T4o",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "94o",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "84o",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "74o",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "64o",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "54o",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "44",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "43s",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "42s",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },

    {
        l: "A3o",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "K3o",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "Q3o",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "J3o",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "T3o",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "93o",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "83o",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "73o",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "63o",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "53o",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "43o",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "33",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "32s",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },

    {
        l: "A2o",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "K2o",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "Q2o",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "J2o",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "T2o",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "92o",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "82o",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "72o",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "62o",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "52o",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "42o",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "32o",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
    {
        l: "22",
        a: [
            {t: "c", v: [{str: 40, ev: -0.5}]},
        ]

    },
];